import * as React from "react";
import { P, H1, Content } from "../recurso_literario.js";
import { useContext } from "react";
import { DomainContext } from "../../Context/Context.js";


export const PanelWeb = () => {
	const { cloudName } = useContext(DomainContext)

	return(
		<Content>
			<H1>Panel WEB</H1>
			<P>
				Podrás acceder y gestionar {cloudName} mediante su aplicación WEB.
			</P>
		</Content>
	)
}

export const DetailPanel = () => {
    return (
		<Content>
            <H1> Detalle </H1>
			<P>
                El primer panel es el de Detalles y tiene el propósito de hacer un resumen
				de todos los servicios contratados y del consumo en general.
			</P>
			<P>
                <img src="/img/Detalles/DPanel.PNG" alt="Inicial"/>
			</P>
			<P>
                El resumen de los servicios y el consumo es tanto la vista principal
				al iniciar sesión como si accedes a él desde el menú de la izquierda de la
				pantalla.
			</P>
			<P>
				El Control de Consumos te muestra el monto que llevas acumulado en lo que va del mes
				en curso y el monto estimado al que llegarás a fin de mes si continúas con esta
				tendencia y sin desplegar o eliminar otros recursos.
			</P>
			<P>
                <img src="/img/Detalles/DResumenConsumos.PNG" alt="Inicial" style={{width:"100%"}}/>
			</P>
			<P>
				El detalle te indica, por cada recurso, la cantidad de elementos desplegados
				en tu nube y en el proyecto en el que te encuentras actualmente.
			</P>
			<P>
                <img src="/img/Detalles/DResumen.PNG" alt="Inicial" style={{width:"100%"}}/>
			</P>
        </Content>
    )
}

export const GestionPanel = () => {
    return(
		<Content>
            <H1> Panel de Gestión </H1>
			<P>
                En el Panel de Gestión se pueden administrar los usuarios, los proyectos y los
				permisos necesarios para los accesos y el manejo de las Nubes.
			</P>
			<P>
                <img src="/img/TPanel.PNG" alt="Menu de Opciones" style={{marginLeft:"40px"}} />
			</P>
			<P>
                Si das click en el ícono de Gestión, se te desplegarán las opciones de Usuarios,
				Proyectos y Permisos.
			</P>
			<P>
                <img src="/img/Gestion/GPanel.PNG" alt="Panel de Gestión" style={{marginLeft:"40px"}} />
			</P>
        </Content>
    )
}

export const GestionUsers = () => {
    return(
        <Content>
            <H1> Usuarios </H1>
            <P>
                Dentro de Gestión encontraremos en Panel de Usuarios, que tiene la funcionalidad
				de crear y administrar los usuarios que gestionarán nuestros proyectos, a su vez
				también se pueden crear grupos de usuarios para una gestión más organizada de los
				mismos.
			</P>
            <P>
                <img src="/img/Gestion/GUsers/GUsers_Button.PNG" alt="Botón de Gestion" style={{marginLeft:"40px"}} />
			</P>
            <P>
                <img src="/img/Gestion/GUsers/GUsers.PNG" alt="Panel de Gestion" style={{marginLeft:"40px"}} />
			</P>
        </Content>
    )
}

export const GestionUsers_Users = () => {
    return(
        <Content>
            <H1> Gestión de Usuarios </H1>
            <P>
                La primera sección corresponde a los usuarios. En esta se puede agregar, editar
				y eliminar los usuarios que van a gestionar los servicios solicitados.
				Encontraremos una tabla que nos mostrará el nombre, el nombre de usuario y el
				estado de los usuarios que vayamos agregando.
			</P>
			<P>
                <img src="/img/Gestion/GUsers/GUsers_Users.PNG"
					alt="Seccion Usuarios" style={{marginLeft:"40px"}} />
			</P>
			<h2>Agregar un Usuario</h2>
			<P>
				Para agregar un nuevo usuario solo tenemos que darle clic al botón de “Agregar”
				que está en la esquina superior izquierda de la sección.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_AddUser.PNG"
					alt="Boton Agregar Usuario" style={{marginLeft:"40px"}} />
			</P>
			<P>
				Nos aparecerá un formulario donde debemos agregar el Nombre, el Correo Electrónico
				y una breve Descripción del usuario que queremos agregar. Luego de ingresar los
				datos debemos dar clic en el botón Aceptar, abajo a la derecha. Luego de esto el
				usuario aparecerá en la tabla de usuarios.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_AddUserFull.PNG"
					alt="Formulario Agregar Usuario" style={{marginLeft:"40px"}} />
			</P>

			<h3>Conocer los Detalles y Modificar un Usuario</h3>
			<P>
				Para conocer los detalles de un usuario creado es necesario dale clic sobre el
				nombre del usuario y esto te dirigirá a la pagina con la información solicitada.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_UserDetail.PNG"
					alt="Detalles Usuario" style={{marginLeft:"40px"}} />
			</P>
			<P>
				Para modificar el usuario solo hay que hacer clic en el botón inferior de la
				página que dice: Editar Usuario. Esto abrirá un formulario donde podrás cambiar
				los datos de este.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_EditDeleteButton_Users.PNG"
					alt="Boton Editar y Eliminar Usuario" style={{marginLeft:"40px"}} />
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_UserUpdate.PNG"
					alt="Modificar Usuario" style={{marginLeft:"40px"}} />
			</P>

			<h3>Eliminar un Usuario</h3>
			<P>
				Para eliminar un usuario creado previamente, hay que hacer clic sobre el nombre
				del usuario, esto te dirigirá a la sección de detalles de este y en la parte
				inferior central da clic en el botón Eliminar.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_EditDeleteButton_Users.PNG"
				alt="Boton Eliminar Usuario" style={{marginLeft:"40px"}} />
			</P>
			<P>
				Una vez dado clic en el botón Eliminar se abrirá una ventana de confirmación de la
				acción donde deberás seleccionar Aceptar para continuar la operación o Cancelar, si
				te arrepentiste de la misma o diste clic al botón de Eliminar por error.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_AlertDeleteUser.PNG"
					alt="Alerta de Eliminar Usuario" style={{marginLeft:"40px"}} />
			</P>
        </Content>
    )
}

export const GestionUsers_Groups = () => {
    return(
		<Content>
			<H1> Gestión de Grupos </H1>
			<P>
				La segunda sección es la de Grupos, en ella puedes crear grupos de usuarios que
				gestionaran y administraran los servicios, esto te permite crear reglas de acceso
				y de acción.
			</P>
			<P>
                <img src="/img/Gestion/GUsers/GUsers_Groups.PNG"
					alt="Seccion Grupos" style={{width:"800px",marginLeft:"40px"}} />
			</P>

			<h2>Agregar un Grupo</h2>
			<P>
				Para agregar un grupo tienes que darle clic al botón Agregar en la esquina
				superior izquierda de la sección de Grupos.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_AddGroups.PNG"
					alt="Boton Agregar Grupo" style={{width:"15%", marginLeft:"40px"}} />
			</P>
			<P>
				Se abrirá una ventana donde debes indicar el nombre y una breve descripción
				de este. Luego le das clic a Aceptar y el nuevo grupo aparecerá en la tabla de
				la sección.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_AddGroupsFull.PNG"
					alt="Formulario Agregar Grupo" style={{width:"50%", marginLeft:"40px"}} />
			</P>

			<h2>Conocer los Detalles y Modificar un Grupo</h2>
			<P>
				Para ver los detalles de un grupo solo basta con darle clic al nombre del
				grupo en la lista de grupos creados y esto te dirigirá a los datos del grupo.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_GroupsDetail.PNG"
					alt="Detalles Grupo" style={{width:"50%", marginLeft:"40px"}} />
			</P>
			<P>
				Para editar un grupo es necesario darle clic al nombre del grupo y en la parte
				inferior de la pantalla hay que darle clic al botón Editar Grupo, luego aparecerá
				una ventana con los datos de este y allí podrás hacer los cambios.
			</P>
			<P>
                <img src="/img/Gestion/GUsers/GUsers_EditDeleteButton_Groups.PNG"
					alt="Boton Editar y Eliminar Grupo" style={{width:"25%", marginLeft:"40px"}} />
			</P>
			<P>
                <img src="/img/Gestion/GUsers/GUsers_GroupUpdate.PNG"
					alt="Modificar Grupo" style={{width:"50%", marginLeft:"40px"}} />
			</P>

			<h2>Gestionar Usuarios de un Grupo</h2>

			<P>
				Si quieres agregar usuarios a un grupo, tienes que darle clic al nombre del grupo,
				luego al botón Editar Usuarios que se encuentra en la parte inferior de la pantalla.
				Luego de esto aparecerá una ventana donde tendrás que dar clic al símbolo de suma
				al lado derecho de los nombres de usuario listados y estos pasaran al cuadro de la
				derecha listado como miembros de ese grupo. Para finalizar da clic en el botón Aceptar.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_AddUserToGroup.PNG"
					alt="Agregar Usuarios a Grupo" style={{width:"50%", marginLeft:"40px"}} />
			</P>

			<h3>Eliminar un Grupo</h3>
			
			<P>
				Para eliminar un grupo creado previamente, hay que hacer clic sobre el nombre del
				grupo, esto te dirigirá a la sección de detalles de este y en la parte inferior
				central da clic en el botón Eliminar.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_EditDeleteButton_Groups.PNG"
					alt="Eliminar Grupo" style={{marginLeft:"40px"}} />
			</P>
			<P>
				Una vez dado clic en el botón Eliminar se abrirá una ventana de confirmación de
				la acción donde deberás seleccionar Aceptar para continuar la operación o Cancelar,
				si te arrepentiste de la misma o diste clic al botón de Eliminar por error.
			</P>
			<P>
				<img src="/img/Gestion/GUsers/GUsers_AlertDeleteGroup.PNG"
					alt="Alerta de Eliminar Grupo" style={{marginLeft:"40px"}} />
			</P>
        </Content>
    )
}

export const GestionPermissions = () => {
    return(
        <Content>
			<H1> Permisos </H1>

			<P>
				La sección de Permisos te permite gestionar las reglas y accesos de los usuarios
				y grupos de usuarios en relación con los proyectos y servicios. Está compuesta por
				3 partes donde se pueden ver los Usuarios y Grupos, los Elementos y las Reglas Aplicadas.
			</P>
			<P>
				<img src="/img/Gestion/GPermissions/GPermissions_Button.PNG"
					alt="Boton Permisos" style={{marginLeft:"40px"}} />
			</P>
			<P>
				<img src="/img/Gestion/GPermissions/GPermissions_ListView.PNG"
					alt="Vista Permisos" style={{maxwidth:"1000px", marginLeft:"40px"}} />
			</P>

			<h3>Usuarios y Grupos</h3>
			<P>
				En esta sección a la izquierda de la pantalla podemos seleccionar a un usuario en
				particular creado previamente o a un grupo de usuarios para conocer qué proyectos
				están relacionados con estos.
			</P>
			<P>
				<img src="/img/Gestion/GPermissions/GPermissions_UsersGroups.PNG"
					alt="Seccion Usuarios" style={{marginLeft:"40px"}} />
			</P>

			<h3>Elementos</h3>
			<P>
				Esta sección se encuentra en el centro de la pantalla y se muestran los
				proyectos que están relacionados con el usuario o grupo seleccionado
				previamente. En forma de árbol podés seleccionar cada proyecto y servicio
				relacionado a este.
			</P>
			<P>
				<img src="/img/Gestion/GPermissions/GPermissions_Elements.PNG"
					alt="Sección Elementos" style={{marginLeft:"40px"}} />
			</P>

			<h3>Reglas Vigentes</h3>
			<P>
				En las reglas vigentes aparecerán los permisos y reglas asignados para cada
				combinación de usuarios, grupos de usuarios y proyectos.
			</P>
			<P>
				<img src="/img/Gestion/GPermissions/GPermissions_Rules.PNG"
					alt="Seccion Reglas" style={{marginLeft:"40px"}} />
			</P>

			<h2>Modificar una Regla</h2>
			<P>
				Para modificar una regla sólo hay que seleccionar al usuario o al grupo de
				usuarios al que se le quiere aplicar la misma, luego seleccionar la nube, el proyecto o 
				el elemento relacionado a este usuario o grupo de usuarios en la sección Elementos.
				Una vez seleccionada una opción de cada una de las secciones, se habilitará el botón que se 
				encuetra en el centro de la barra inferior, el botón de Modificar.
			</P>
			<P>
				<img src="/img/Gestion/GPermissions/GPermissions_EditButton.PNG"
					alt="Boton Editar" style={{marginLeft:"40px"}} />
			</P>
			<P>
				Luego de dar clic sobre el botón Modificar aparecerá una ventana donde podrás
				habilitar o permitir (opción Permit) o deshabilitar o denegar (opción Deny) alguna
				de las reglas o permisos disponibles. Primero se debe seleccionar la regla a modificar a través
				del checkbox que se encuentra a la izquierda de cada regla, luego la
				opción de permitir o denegar y al final de esta ventana el botón Aceptar.
				Las modificaciones se verán reflejadas en la sección Reglas Vigentes.
				Pasando el cursor sobre el nombre de cada regla tendrás la descripción de cada una.
			</P>
			<P>
				<img src="/img/Gestion/GPermissions/GPermissions_UpdateRules.PNG"
					alt="Modificar Reglas" style={{marginLeft:"40px"}} />
			</P>
        </Content>
    )
}

export const StoragePanel = () => {
    return(
		<Content>
			<h2> Panel de Almacenamiento </h2>
			<P>
				En el panel de Almacenamiento podés crear, gestionar y administrar los distintos servicios de
				almacenamiento para tu nube.
			</P>
			<P>
				Si das clic en el icono de Almacenamiento, se te desplegaran las distintas opciones.
			</P>
			<P>
				<img src="/img/Storage/SPanel.PNG" alt="Panel de Storage" style={{width:"30%", marginLeft:"40px"}} />
			</P>
        </Content>
    )
}

export const StorageVolumenes = () => {
    return(
        <Content>
			<H1> Volúmenes </H1>
			<P>
				En la sección de Volúmenes puedes crear, gestionar y administrar los volúmenes de almacenamiento.
			</P>
			<P>
                <img src="/img/Storage/SVolumenes/SVolumenes_View.PNG"
					alt="Vista de Volumenes" style={{width:"100%", marginLeft:"40px"}} />
			</P>

			<h2>Agregar un Volumen por Bloque</h2>
			<P>
				Para agregar un nuevo Volumen es necesario dar clic en el botón Agregar de la esquina 
				superior izquierda de la vista.
			</P>
			<P>
				<img src="/img/Storage/SVolumenes/SVolumenes_AddButton.PNG"
					alt="Botón Agregar Volumen" style={{width:"25%", marginLeft:"40px"}} />
			</P>
			<P>
				Se abrirá una vista dividida en dos, donde del lado izquierdo tenemos el presupuesto
				a pagar de acuerdo con la configuración del servicio escogida y del lado derecho
				un formulario para cargar los datos del nuevo Volumen de almacenamiento.
			</P>
			<P>
				<img src="/img/Storage/SVolumenes/SVolumenes_AddView.PNG"
					alt="Vista Agregar Volumen" style={{width:"80%", marginLeft:"40px"}} />
			</P>
			<P>
				Para empezar con la configuración del nuevo Volumen debes llenar el formulario de la
				derecha indicando el nombre, el tamaño del volumen en GB y la calidad de este en la
				lista desplegable, para continuar debes darle clic al botón siguiente de la zona
				inferior derecha de la vista.
			</P>
			<P>
				<img src="/img/Storage/SVolumenes/SVolumenes_AddForm.PNG"
					alt="Formulario Agregar Volumen" style={{width:"50%", marginLeft:"40px"}} />
			</P>
			<P>
				Para finalizar debés confirmar que los datos escogidos son los correctos para luego
				darle clic al botón Crear Volumen en la zona inferior derecha de la vista.
			</P>
			<P>
				<img src="/img/Storage/SVolumenes/SVolumenes_AddConfirm.PNG"
					alt="Confirmar Agregar Volumen" style={{width:"50%", marginLeft:"40px"}} />
			</P>
			<P>
				Podrás visualizar el nuevo volumen creado en la lista principal del panel de Volúmenes.
			</P>
			<P>
				<img src="/img/Storage/SVolumenes/SVolumenes_AddList.PNG"
					alt="Lista Agregar Volumen" style={{width:"100%", marginLeft:"40px"}} />
			</P>

			<h2>Detalles del Volumen</h2>
			<P>
				Para conocer la información detallada de un Volumen sólo debés darle clic al nombre
				de este en la lista principal del panel de Volúmenes.
				Además, en el apartado Finanzas verás lo consumido actualmente, el precio por hora y el 
				estimado a fin de mes.
			</P>
			<P>
				<img src="/img/Storage/SVolumenes/SVolumenes_Detail.PNG"
					alt="Detalles del Volumen" style={{width:"80%", marginLeft:"40px"}} />
			</P>

			<h2>Eliminar un Volumen</h2>

			<P>
				Para eliminar un Volumen, debemos dar clic en el nombre de este para ir a la vista
				detallada de este, luego en la parte inferior de la vista podremos encontrar el botón
				Eliminar.
			</P>
			<P>
				<img src="/img/Storage/SVolumenes/SVolumenes_DeleteButton.PNG"
					alt="Boton Eliminar Volumen" style={{marginLeft:"40px"}} />
			</P>
			<P>
				Al dar clic nos aparece una ventana emergente para confirmar la decisión y al dar
				Aceptar podremos eliminar el Volumen de manera definitiva o podemos dar clic en Cancelar
				y volver a la vista anterior en el caso de que hayamos dado clic por error.
			</P>
			<P>
				<img src="/img/Storage/SVolumenes/SVolumenes_DeleteConfirm.PNG"
					alt="Boton Eliminar Volumen" style={{width:"50%", marginLeft:"40px"}} />
			</P>
        </Content>
	)
}
